import React, { useEffect } from "react";
import Layout from "../../NewComponent/Layout/Layout";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import Filters from "./Filters";
import { seekerPagesApi, getTabSearchData2 } from "../../API/api";
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import PaginationComp from "../../NewComponent/Pagination/Pagination";
import {Spin, Empty} from 'antd';
import RenderQA from "./RenderQA";
import AnsweredQA from '../../NewComponent/answerBox/SeekerAnswered/index';
import KeyTagDataBox from '../KeyTermPage/KeyTagDataBox';

export default function SeekerAnsweredPage() {
  const answeredState = useSelector((state) => state.answeredQuestions);
  const keyTagState = useSelector(state=>state.keyTag);
  const dispatch = useDispatch();
  const {updateAnsweredTabData, updatePageNoAnswered, IsLoadingAnsweredtab} = bindActionCreators(Actions, dispatch)
  const { pageNo, sortFilter, sortChange, domains,searchQuery } = answeredState;
  const container = {
    width: "74%",
    margin: "auto",
    marginTop: "1%",
    marginBottom: "7%",
    border: "1px solid #E0E2E6",
    background: "#FFFFFF",
    borderRadius: "12px",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "28px",
  };
  const onChangePageNo = (page) =>{
    updatePageNoAnswered(page-1);
  }
  const fetchAnswered = () => {
    if(answeredState.searchQuery.length===0){
      IsLoadingAnsweredtab(true);
    seekerPagesApi(
      pageNo,
      sortFilter.origValue,
      sortFilter.sortOrder,
      sortChange,
      domains,
      "answered"
    ).then((res) => {
      if (res === undefined) {
        return;
      }
      updateAnsweredTabData({data:res.data.data, count:res.data.count});
      IsLoadingAnsweredtab(false);
    });
    }else{
      IsLoadingAnsweredtab(true);
  //     pageNo,
  // status,
  // sortFilter,
  // question,
  // sortOrder,
  // sortChange,
  // domains,
  // category = null,
  getTabSearchData2(pageNo,"answered",sortFilter.origValue,searchQuery,sortFilter.sortOrder,sortChange,domains,null).then(res=>{
    if (res === undefined) {
      return;
    }
    updateAnsweredTabData({data:res.data.data, count:res.data.count});
    IsLoadingAnsweredtab(false);
  })
    }
  };
  useEffect(() => {
    fetchAnswered();
  }, [
    answeredState.domains,
    answeredState.sortFilter,
    answeredState.searchQuery,
    answeredState.pageNo,
    answeredState.reload
  ]);
  return (
    <Layout>
      {!keyTagState.isBack && <div style={{
          width: "74%",
          margin: "auto",
          marginTop: "1%",
          marginBottom: "3%",
        }}>
        <SearchBar/>
        </div>}
      <div style={container}>
       {!keyTagState.isBack &&<div>
       <div className="mb-4">
       <Filters />
       </div>
        {answeredState.isLoading &&<Spin size="large" spinning={true}>
          <div style={{ height: "100px" }}></div>
        </Spin>}
        {!answeredState.isLoading && answeredState.data2.length === 0 && <div className="mt-4"><Empty /></div>}
        {!answeredState.isLoading && answeredState.data2.length !== 0 && answeredState.data2.map(qa=>{
          return(
            <AnsweredQA data={qa.answersList} question={qa} />
          )
        })}
        {answeredState.data2.length !== 0 && !answeredState.isLoading &&<div className="mt-3" style={{display:'flex', justifyContent:'end'}}>
        <PaginationComp page={answeredState.pageNo+1} total={answeredState.totalCount} onChangeFunc={onChangePageNo} />
        </div>}
       </div>}
       {keyTagState.isBack && <KeyTagDataBox />}
      </div>
    </Layout>
  );
}
